import type { Operator } from '@@partner:types:app'
import type { CRUD_Variables, GQL_Edge } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_EMPLOYEE_FIELDS,
  SHORTCUT_PAGE_INFO_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllOperatorsQueryResult {
  operators: GQL_Edge<Operator[]>
}

export interface AllOperatorsQueryVariables extends CRUD_Variables {}

const GQL_QUERY_EMPLOYEES_STATS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    operators: allOperators(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_EMPLOYEE_FIELDS}
        email
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllOperators = (variables: AllOperatorsQueryVariables) =>
  useQuery<AllOperatorsQueryResult, AllOperatorsQueryVariables>(
    GQL_QUERY_EMPLOYEES_STATS,
    { variables, fetchPolicy: 'cache-and-network' }
  )
